import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Logo } from '../components/Logo';
import { Check, ChevronRight, ArrowLeft, Users, X, Plus } from 'lucide-react';
const TOTAL_STEPS = 4;
export function OnboardingPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [inviteEmails, setInviteEmails] = useState<string[]>(['']);
  const handleNext = () => {
    if (step < TOTAL_STEPS) setStep(step + 1);else navigate('/dashboard');
  };
  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };
  const handleSkip = () => {
    handleNext();
  };
  const addEmailField = () => {
    if (inviteEmails.length < 10) {
      setInviteEmails([...inviteEmails, '']);
    }
  };
  const updateEmail = (index: number, value: string) => {
    const updated = [...inviteEmails];
    updated[index] = value;
    setInviteEmails(updated);
  };
  const removeEmail = (index: number) => {
    if (inviteEmails.length > 1) {
      setInviteEmails(inviteEmails.filter((_, i) => i !== index));
    }
  };
  const isInviteStep = step === 3;
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-904">
      <header className="h-20 px-8 flex items-center justify-between shrink-0" data-id="element-905">
        <Logo data-id="element-906" />
        <div className="flex items-center gap-2" data-id="element-907">
          {Array.from({
          length: TOTAL_STEPS
        }, (_, i) => i + 1).map(i => <div key={i} className="flex items-center" data-id="element-908">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-colors ${step === i ? 'bg-brand-500 text-white' : step > i ? 'bg-emerald-500 text-white' : 'bg-slate-200 text-slate-400'}`} data-id="element-909">
                {step > i ? <Check size={14} data-id="element-910" /> : i}
              </div>
              {i < TOTAL_STEPS && <div className={`w-12 h-px mx-2 transition-colors ${step > i ? 'bg-emerald-500' : 'bg-slate-200'}`} data-id="element-911" />}
            </div>)}
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-6" data-id="element-912">
        <div className="w-full max-w-lg bg-white rounded-xl shadow-card border border-slate-200 overflow-hidden" data-id="element-913">
          <AnimatePresence mode="wait" data-id="element-914">
            {step === 1 && <motion.div key="step1" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="p-8" data-id="element-915">
                <h2 className="text-xl text-navy-950 mb-2" data-id="element-916">
                  Datos de la empresa
                </h2>
                <p className="text-sm text-navy-600 mb-8" data-id="element-917">
                  Configuremos su espacio de trabajo corporativo.
                </p>

                <div className="space-y-5" data-id="element-918">
                  <div className="space-y-1.5" data-id="element-919">
                    <label className="block text-sm font-medium text-navy-950" data-id="element-920">
                      Nombre de la empresa
                    </label>
                    <input type="text" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" placeholder="Ej. PharmaCorp SA" data-id="element-921" />
                  </div>
                  <div className="space-y-1.5" data-id="element-922">
                    <label className="block text-sm font-medium text-navy-950" data-id="element-923">
                      Rubro / Industria
                    </label>
                    <select className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 bg-white" data-id="element-924">
                      <option value="" data-id="element-925">Seleccione una industria...</option>
                      <option value="farma" data-id="element-926">Farmacéutica</option>
                      <option value="legal" data-id="element-927">Legal / Estudios</option>
                      <option value="salud" data-id="element-928">Salud / Hospitales</option>
                      <option value="gobierno" data-id="element-929">Gobierno</option>
                      <option value="otro" data-id="element-930">Otro</option>
                    </select>
                  </div>
                  <div className="space-y-1.5" data-id="element-931">
                    <label className="block text-sm font-medium text-navy-950" data-id="element-932">
                      Cantidad de empleados
                    </label>
                    <select className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 bg-white" data-id="element-933">
                      <option value="" data-id="element-934">Seleccione un rango...</option>
                      <option value="1-10" data-id="element-935">1 - 10</option>
                      <option value="11-50" data-id="element-936">11 - 50</option>
                      <option value="51-200" data-id="element-937">51 - 200</option>
                      <option value="201+" data-id="element-938">Más de 200</option>
                    </select>
                  </div>
                </div>
              </motion.div>}

            {step === 2 && <motion.div key="step2" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="p-8" data-id="element-939">
                <h2 className="text-xl text-navy-950 mb-2" data-id="element-940">
                  Datos del usuario
                </h2>
                <p className="text-sm text-navy-600 mb-8" data-id="element-941">
                  Complete su perfil de administrador.
                </p>

                <div className="space-y-5" data-id="element-942">
                  <div className="grid grid-cols-2 gap-4" data-id="element-943">
                    <div className="space-y-1.5" data-id="element-944">
                      <label className="block text-sm font-medium text-navy-950" data-id="element-945">
                        Nombre
                      </label>
                      <input type="text" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" data-id="element-946" />
                    </div>
                    <div className="space-y-1.5" data-id="element-947">
                      <label className="block text-sm font-medium text-navy-950" data-id="element-948">
                        Apellido
                      </label>
                      <input type="text" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" data-id="element-949" />
                    </div>
                  </div>
                  <div className="space-y-1.5" data-id="element-950">
                    <label className="block text-sm font-medium text-navy-950" data-id="element-951">
                      Cargo / Rol
                    </label>
                    <input type="text" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" placeholder="Ej. Director de Asuntos Regulatorios" data-id="element-952" />
                  </div>
                  <div className="space-y-1.5" data-id="element-953">
                    <label className="block text-sm font-medium text-navy-950" data-id="element-954">
                      ¿Cómo nos conoció?
                    </label>
                    <select className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 bg-white" data-id="element-955">
                      <option value="" data-id="element-956">Seleccione una opción...</option>
                      <option value="google" data-id="element-957">Búsqueda web</option>
                      <option value="linkedin" data-id="element-958">LinkedIn</option>
                      <option value="referencia" data-id="element-959">Recomendación</option>
                      <option value="evento" data-id="element-960">Evento / Conferencia</option>
                    </select>
                  </div>
                </div>
              </motion.div>}

            {step === 3 && <motion.div key="step3" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="p-8" data-id="element-961">
                <div className="flex items-center gap-3 mb-2" data-id="element-962">
                  <div className="w-9 h-9 rounded-lg bg-brand-50 flex items-center justify-center" data-id="element-963">
                    <Users size={18} className="text-brand-600" data-id="element-964" />
                  </div>
                  <div data-id="element-965">
                    <h2 className="text-xl text-navy-950" data-id="element-966">
                      Invite a su equipo
                    </h2>
                  </div>
                </div>
                <p className="text-sm text-navy-600 mb-6" data-id="element-967">
                  Agregue colaboradores para trabajar juntos. Puede omitir este
                  paso e invitarlos más tarde.
                </p>

                <div className="space-y-3 mb-4" data-id="element-968">
                  {inviteEmails.map((email, index) => <div key={index} className="flex items-center gap-2" data-id="element-969">
                      <input type="email" value={email} onChange={e => updateEmail(index, e.target.value)} placeholder="colaborador@empresa.com" className="flex-1 h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500" data-id="element-970" />
                      <select className="h-10 px-3 rounded-md border border-slate-200 text-sm outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500 bg-white w-28 shrink-0" data-id="element-971">
                        <option value="editor" data-id="element-972">Editor</option>
                        <option value="viewer" data-id="element-973">Viewer</option>
                        <option value="admin" data-id="element-974">Admin</option>
                      </select>
                      {inviteEmails.length > 1 && <button onClick={() => removeEmail(index)} className="text-slate-400 hover:text-rose-500 p-1 shrink-0 transition-colors" data-id="element-975">
                          <X size={16} data-id="element-976" />
                        </button>}
                    </div>)}
                </div>

                <button onClick={addEmailField} className="flex items-center gap-2 text-sm font-medium text-brand-500 hover:text-brand-400 transition-colors" data-id="element-977">
                  <Plus size={14} data-id="element-978" />
                  Agregar otro
                </button>

                <div className="mt-6 bg-slate-50 rounded-lg border border-slate-200 p-3 flex items-start gap-3" data-id="element-979">
                  <div className="text-slate-400 mt-0.5 shrink-0" data-id="element-980">
                    <Users size={14} data-id="element-981" />
                  </div>
                  <p className="text-xs text-navy-600" data-id="element-982">
                    Las invitaciones se enviarán por email. Los colaboradores
                    podrán acceder a las alertas y búsquedas de su organización
                    según el rol asignado.
                  </p>
                </div>
              </motion.div>}

            {step === 4 && <motion.div key="step4" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="p-8" data-id="element-983">
                <h2 className="text-xl text-navy-950 mb-2" data-id="element-984">
                  Finalizar configuración
                </h2>
                <p className="text-sm text-navy-600 mb-8" data-id="element-985">
                  Revise los términos para comenzar a utilizar la plataforma.
                </p>

                <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6 h-40 overflow-y-auto text-xs text-navy-600 space-y-2" data-id="element-986">
                  <p className="font-medium text-navy-950" data-id="element-987">
                    Términos y Condiciones de Uso
                  </p>
                  <p data-id="element-988">
                    1. El servicio de WiSoft Alerts se provee "tal cual" para el
                    monitoreo de información pública.
                  </p>
                  <p data-id="element-989">
                    2. La empresa no se responsabiliza por demoras en la
                    publicación original de los boletines oficiales.
                  </p>
                  <p data-id="element-990">
                    3. El uso de la IA generativa para análisis de contexto está
                    sujeto a los límites de su plan contratado.
                  </p>
                  <p data-id="element-991">
                    4. Los datos de su empresa serán tratados bajo nuestra
                    estricta política de privacidad corporativa.
                  </p>
                </div>

                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-992">
                  <div className="relative flex items-center justify-center w-5 h-5 rounded border border-slate-200 bg-white group-hover:border-brand-500 transition-colors shrink-0 mt-0.5" data-id="element-993">
                    <input type="checkbox" className="peer sr-only" data-id="element-994" />
                    <div className="absolute inset-0 bg-brand-500 rounded scale-0 peer-checked:scale-100 transition-transform flex items-center justify-center" data-id="element-995">
                      <Check size={12} className="text-white" data-id="element-996" />
                    </div>
                  </div>
                  <span className="text-sm text-navy-600" data-id="element-997">
                    He leído y acepto los{' '}
                    <a href="#" className="text-brand-500 hover:underline" data-id="element-998">
                      Términos y Condiciones
                    </a>{' '}
                    y la{' '}
                    <a href="#" className="text-brand-500 hover:underline" data-id="element-999">
                      Política de Privacidad
                    </a>
                    .
                  </span>
                </label>
              </motion.div>}
          </AnimatePresence>

          <div className="p-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between" data-id="element-1000">
            <button onClick={handleBack} className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-md transition-colors ${step === 1 ? 'opacity-0 pointer-events-none' : 'text-navy-600 hover:bg-slate-200'}`} data-id="element-1001">
              <ArrowLeft size={16} data-id="element-1002" />
              Atrás
            </button>

            <div className="flex items-center gap-3" data-id="element-1003">
              {isInviteStep && <button onClick={handleSkip} className="text-sm font-medium text-slate-400 hover:text-navy-950 px-4 py-2 rounded-md hover:bg-slate-200 transition-colors" data-id="element-1004">
                  Omitir
                </button>}
              <button onClick={handleNext} className="flex items-center gap-2 bg-brand-500 hover:bg-brand-400 text-white text-sm font-medium px-6 py-2 rounded-md transition-colors shadow-sm" data-id="element-1005">
                {step === TOTAL_STEPS ? 'Comenzar' : isInviteStep ? 'Enviar invitaciones' : 'Siguiente'}
                {step < TOTAL_STEPS && !isInviteStep && <ChevronRight size={16} data-id="element-1006" />}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}